<template>
  <v-container class="d-flex flex-column">
    <v-form ref="form" v-model="valid" class="d-flex flex-column">
      <template v-if="!isEmpty(fields)">
        <template v-for="field in fields">
          <CustomInput
            :ref="field.identifier"
            :key="field.identifier"
            :field="field"
            :form-data="formData"
            :possible-fields="possibleFields"
            @attachment-change="handleAttachments"
          />
        </template>
      </template>
    </v-form>
    <v-alert class="alert-message" style="white-space: pre-line" :value="!!errorMessage" type="error" outlined>
      {{ errorMessage }}
    </v-alert>
  </v-container>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import { createLink } from '@/api/helpers'
import joinPath from 'path.join'
import { api } from '@/api'

export default {
  name: 'CustomForm',
  props: {
    defaultFields: {
      type: Array,
      default: () => [],
    },
    model: {
      type: String,
      default: () => 'advance',
    },
    possibleFields: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      customForm: false,
      errorMessage: '',
      formData: this.value,
      fields: [],
      valid: null,
    }
  },
  computed: {
    attachmentsComponent() {
      if (this.$refs.attachments && this.$refs.attachments[0]) {
        return this.$refs.attachments[0].$refs.component
      }
      return null
    },
    fileUpload() {
      return this.attachmentsComponent?.fileUpload
    },
    hasAttachments() {
      return this.attachmentsComponent?.$refs.input.files.some(({ file }) => file !== '') ?? false
    },
  },
  watch: {
    'formData.business_type'(_) {
      this.fetchForm()
    },
    formData(_) {
      this.$emit('input', this.formData)
    },
  },
  async mounted() {
    await this.fetchForm()
  },
  methods: {
    isEmpty,
    cleanup() {
      this.$refs.form.resetValidation()
      this.attachmentsComponent?.cleanup()
      this.formData = {}
      this.errorMessage = ''
    },
    async fetchForm() {
      this.fields = this.possibleFields
      if (!isEmpty(this.defaultFields)) {
        this.fields = Object.keys(this.fields)
          .filter((identifier) => this.defaultFields.includes(identifier))
          .reduce((field, identifier) => {
            field[identifier] = this.fields[identifier]
            return field
          }, {})
      }

      const path = createLink(joinPath('forms', 'fetch_form'))
      const params = { model: this.model, type_id: this.formData.business_type }
      const { data } = await api.get(path, { params })

      if (!isEmpty(data)) {
        this.formData.form_id = data.id
        this.fields = data.fields
        this.customForm = true
      } else {
        this.customForm = false
      }
    },
    getFiles() {
      // Return an array of files (non-empty file fields).
      if (this.fileUpload) {
        return this.fileUpload.map((f) => (f.files.length ? f.files[0] : null)).filter((f) => f !== null)
      }
      return []
    },
    getFormData(data) {
      const formData = new FormData()
      formData.append('payload', JSON.stringify(data))
      this.getFiles().forEach((f) => {
        formData.append('files', f)
      })

      return formData
    },
    handleAttachments(attachments) {
      this.formData.attachments = attachments
      this.$emit('attachment-change', attachments)
    },
  },
}
</script>

<style scoped>
.v-container {
  max-width: 2pxem !important;
  max-height: 2em !important;
}
</style>
